import { useState } from "react";
import useDidUpdateEffect from "src/share/hooks/useDidUpdateEffect";

const useLangFilter = (initialValue, fn) => {
  const [lang, setLang] = useState(initialValue);
  useDidUpdateEffect(() => {
    fn();
  }, [lang]);

  return [lang, setLang];
};

export default useLangFilter;



// WEBPACK FOOTER //
// ./src/modules/News/hooks/useLangFilter.ts